import { t } from "@lingui/macro";
import { range } from "lodash";

import {
  Crementor,
  SelectableTile,
} from "@whoosh/design-system/src/components/controls";
import {
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

type GroupSizeOption = {
  value: number | undefined;
  label: string;
};

type Props = {
  controlMinGroupSize: number;
  controlMaxGroupSize: number;
  selectedGroupSize: number | undefined;
  onChange: (value: number | undefined) => void;
  forceCrementor?: boolean;
};

export const GroupSizeFilterControl = ({
  controlMinGroupSize,
  controlMaxGroupSize,
  selectedGroupSize,
  onChange,
  forceCrementor = false,
}: Props) => {
  const options = [
    {
      value: undefined,
      label: t`All`,
    } as GroupSizeOption,
  ].concat(
    range(controlMinGroupSize, controlMaxGroupSize + 1, 1).map<GroupSizeOption>(
      (value) => ({ value: value, label: value.toString() })
    )
  );

  const shouldUseCrementor = forceCrementor || options.length > 6;

  return (
    <VStack gap={4}>
      <Text variant="mainSmallSemiBold">{t`Group Size`}</Text>
      {shouldUseCrementor ? (
        <Crementor
          value={selectedGroupSize || controlMinGroupSize}
          max={controlMaxGroupSize}
          min={controlMinGroupSize}
          onIncrement={onChange}
          onDecrement={onChange}
        />
      ) : (
        <HStack gap={2}>
          {options.map((option) => (
            <SelectableTile
              isSmall
              align="center"
              key={option.label}
              title={t`${option.label}`}
              setSelected={(isSelected) =>
                isSelected ? onChange(option.value) : null
              }
              isSelected={selectedGroupSize === option.value}
            />
          ))}
        </HStack>
      )}
    </VStack>
  );
};
